import { render, staticRenderFns } from "./Discuss.vue?vue&type=template&id=0e829a36&scoped=true&"
import script from "./Discuss.vue?vue&type=script&lang=js&"
export * from "./Discuss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e829a36",
  null
  
)

export default component.exports